/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  DashboardWidgetGroupValueV8,
  DashboardWidgetMappingPatchRequestV8,
  GetV8DashboardsWidgetsPackParams,
  GetV8DashboardsWidgetsParams,
  PatchV8DashboardsWidgetsPackParams,
  PostV8DashboardsWidgetsPackExportParams,
  PostV8DashboardsWidgetsPackImportParams,
  PostV8DashboardsWidgetsPackParams,
  PostV8DashboardsWidgetsParams,
  PutV8DashboardsWidgetsByWidgetValueIdParams,
  SuccessResponse,
  WidgetMappingResponseV8,
  WidgetPackPatchRequest,
  WidgetPackRegisterRequestV8,
  WidgetPackResponseV8,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 위젯 리스트
 */
export const getV8DashboardsWidgets = (
  params: MaybeRef<GetV8DashboardsWidgetsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WidgetMappingResponseV8>(
    { url: `/api/v8/dashboards/widgets`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsWidgetsQueryKey = (
  params?: MaybeRef<GetV8DashboardsWidgetsParams>,
) => {
  return ['api', 'v8', 'dashboards', 'widgets', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsWidgetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgets>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsWidgetsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsWidgetsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsWidgets>>> = ({ signal }) =>
    getV8DashboardsWidgets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsWidgets>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsWidgetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsWidgets>>
>;
export type GetV8DashboardsWidgetsQueryError = ErrorType<unknown>;

/**
 * @summary 위젯 리스트
 */

export function useGetV8DashboardsWidgets<
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgets>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8DashboardsWidgetsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsWidgetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 위젯 추가/수정/삭제
 */
export const postV8DashboardsWidgets = (
  dashboardWidgetMappingPatchRequestV8: MaybeRef<DashboardWidgetMappingPatchRequestV8>,
  params?: MaybeRef<PostV8DashboardsWidgetsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardWidgetMappingPatchRequestV8 = unref(dashboardWidgetMappingPatchRequestV8);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardWidgetMappingPatchRequestV8,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsWidgetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsWidgets>>,
    TError,
    {
      data: BodyType<DashboardWidgetMappingPatchRequestV8>;
      params?: PostV8DashboardsWidgetsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsWidgets>>,
  TError,
  { data: BodyType<DashboardWidgetMappingPatchRequestV8>; params?: PostV8DashboardsWidgetsParams },
  TContext
> => {
  const mutationKey = ['postV8DashboardsWidgets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsWidgets>>,
    { data: BodyType<DashboardWidgetMappingPatchRequestV8>; params?: PostV8DashboardsWidgetsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8DashboardsWidgets(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsWidgetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsWidgets>>
>;
export type PostV8DashboardsWidgetsMutationBody = BodyType<DashboardWidgetMappingPatchRequestV8>;
export type PostV8DashboardsWidgetsMutationError = ErrorType<unknown>;

/**
 * @summary 위젯 추가/수정/삭제
 */
export const usePostV8DashboardsWidgets = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsWidgets>>,
      TError,
      {
        data: BodyType<DashboardWidgetMappingPatchRequestV8>;
        params?: PostV8DashboardsWidgetsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsWidgets>>,
  TError,
  { data: BodyType<DashboardWidgetMappingPatchRequestV8>; params?: PostV8DashboardsWidgetsParams },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsWidgetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 팩 목록 조회
 */
export const getV8DashboardsWidgetsPack = (
  params?: MaybeRef<GetV8DashboardsWidgetsPackParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WidgetPackResponseV8>(
    { url: `/api/v8/dashboards/widgets/pack`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DashboardsWidgetsPackQueryKey = (
  params?: MaybeRef<GetV8DashboardsWidgetsPackParams>,
) => {
  return ['api', 'v8', 'dashboards', 'widgets', 'pack', ...(params ? [params] : [])] as const;
};

export const getGetV8DashboardsWidgetsPackQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsWidgetsPackParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsWidgetsPackQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>> = ({
    signal,
  }) => getV8DashboardsWidgetsPack(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsWidgetsPackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>
>;
export type GetV8DashboardsWidgetsPackQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 팩 목록 조회
 */

export function useGetV8DashboardsWidgetsPack<
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DashboardsWidgetsPackParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgetsPack>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsWidgetsPackQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 뷰팩 추가
 */
export const postV8DashboardsWidgetsPack = (
  widgetPackRegisterRequestV8: MaybeRef<WidgetPackRegisterRequestV8>,
  params?: MaybeRef<PostV8DashboardsWidgetsPackParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  widgetPackRegisterRequestV8 = unref(widgetPackRegisterRequestV8);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets/pack`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: widgetPackRegisterRequestV8,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsWidgetsPackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>,
    TError,
    { data: BodyType<WidgetPackRegisterRequestV8>; params?: PostV8DashboardsWidgetsPackParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>,
  TError,
  { data: BodyType<WidgetPackRegisterRequestV8>; params?: PostV8DashboardsWidgetsPackParams },
  TContext
> => {
  const mutationKey = ['postV8DashboardsWidgetsPack'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>,
    { data: BodyType<WidgetPackRegisterRequestV8>; params?: PostV8DashboardsWidgetsPackParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8DashboardsWidgetsPack(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsWidgetsPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>
>;
export type PostV8DashboardsWidgetsPackMutationBody = BodyType<WidgetPackRegisterRequestV8>;
export type PostV8DashboardsWidgetsPackMutationError = ErrorType<unknown>;

/**
 * @summary 뷰팩 추가
 */
export const usePostV8DashboardsWidgetsPack = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>,
      TError,
      { data: BodyType<WidgetPackRegisterRequestV8>; params?: PostV8DashboardsWidgetsPackParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPack>>,
  TError,
  { data: BodyType<WidgetPackRegisterRequestV8>; params?: PostV8DashboardsWidgetsPackParams },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsWidgetsPackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 뷰팩 수정/삭제
 */
export const patchV8DashboardsWidgetsPack = (
  widgetPackPatchRequest: MaybeRef<WidgetPackPatchRequest>,
  params?: MaybeRef<PatchV8DashboardsWidgetsPackParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  widgetPackPatchRequest = unref(widgetPackPatchRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets/pack`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: widgetPackPatchRequest,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV8DashboardsWidgetsPackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>,
    TError,
    { data: BodyType<WidgetPackPatchRequest>; params?: PatchV8DashboardsWidgetsPackParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>,
  TError,
  { data: BodyType<WidgetPackPatchRequest>; params?: PatchV8DashboardsWidgetsPackParams },
  TContext
> => {
  const mutationKey = ['patchV8DashboardsWidgetsPack'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>,
    { data: BodyType<WidgetPackPatchRequest>; params?: PatchV8DashboardsWidgetsPackParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV8DashboardsWidgetsPack(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8DashboardsWidgetsPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>
>;
export type PatchV8DashboardsWidgetsPackMutationBody = BodyType<WidgetPackPatchRequest>;
export type PatchV8DashboardsWidgetsPackMutationError = ErrorType<unknown>;

/**
 * @summary 뷰팩 수정/삭제
 */
export const usePatchV8DashboardsWidgetsPack = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>,
      TError,
      { data: BodyType<WidgetPackPatchRequest>; params?: PatchV8DashboardsWidgetsPackParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8DashboardsWidgetsPack>>,
  TError,
  { data: BodyType<WidgetPackPatchRequest>; params?: PatchV8DashboardsWidgetsPackParams },
  TContext
> => {
  const mutationOptions = getPatchV8DashboardsWidgetsPackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 뷰팩 내보내기
 */
export const postV8DashboardsWidgetsPackExport = (
  params: MaybeRef<PostV8DashboardsWidgetsPackExportParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets/pack/export`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsWidgetsPackExportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>,
    TError,
    { params: PostV8DashboardsWidgetsPackExportParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>,
  TError,
  { params: PostV8DashboardsWidgetsPackExportParams },
  TContext
> => {
  const mutationKey = ['postV8DashboardsWidgetsPackExport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>,
    { params: PostV8DashboardsWidgetsPackExportParams }
  > = (props) => {
    const { params } = props ?? {};

    return postV8DashboardsWidgetsPackExport(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsWidgetsPackExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>
>;

export type PostV8DashboardsWidgetsPackExportMutationError = ErrorType<unknown>;

/**
 * @summary 뷰팩 내보내기
 */
export const usePostV8DashboardsWidgetsPackExport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>,
      TError,
      { params: PostV8DashboardsWidgetsPackExportParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackExport>>,
  TError,
  { params: PostV8DashboardsWidgetsPackExportParams },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsWidgetsPackExportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary importWidgetPackAttribute
 */
export const postV8DashboardsWidgetsPackImport = (
  postV8DashboardsWidgetsPackImportBody: MaybeRef<string[]>,
  params?: MaybeRef<PostV8DashboardsWidgetsPackImportParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  postV8DashboardsWidgetsPackImportBody = unref(postV8DashboardsWidgetsPackImportBody);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets/pack/import`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postV8DashboardsWidgetsPackImportBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsWidgetsPackImportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>,
    TError,
    { data: BodyType<string[]>; params?: PostV8DashboardsWidgetsPackImportParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>,
  TError,
  { data: BodyType<string[]>; params?: PostV8DashboardsWidgetsPackImportParams },
  TContext
> => {
  const mutationKey = ['postV8DashboardsWidgetsPackImport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>,
    { data: BodyType<string[]>; params?: PostV8DashboardsWidgetsPackImportParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8DashboardsWidgetsPackImport(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsWidgetsPackImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>
>;
export type PostV8DashboardsWidgetsPackImportMutationBody = BodyType<string[]>;
export type PostV8DashboardsWidgetsPackImportMutationError = ErrorType<unknown>;

/**
 * @summary importWidgetPackAttribute
 */
export const usePostV8DashboardsWidgetsPackImport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>,
      TError,
      { data: BodyType<string[]>; params?: PostV8DashboardsWidgetsPackImportParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsPackImport>>,
  TError,
  { data: BodyType<string[]>; params?: PostV8DashboardsWidgetsPackImportParams },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsWidgetsPackImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 위젯 하나 수정
 */
export const putV8DashboardsWidgetsByWidgetValueId = (
  widgetValueId: MaybeRef<number>,
  dashboardWidgetGroupValueV8: MaybeRef<DashboardWidgetGroupValueV8>,
  params: MaybeRef<PutV8DashboardsWidgetsByWidgetValueIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  widgetValueId = unref(widgetValueId);
  dashboardWidgetGroupValueV8 = unref(dashboardWidgetGroupValueV8);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v8/dashboards/widgets/${widgetValueId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardWidgetGroupValueV8,
      params: unref(params),
    },
    options,
  );
};

export const getPutV8DashboardsWidgetsByWidgetValueIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>,
    TError,
    {
      widgetValueId: number;
      data: BodyType<DashboardWidgetGroupValueV8>;
      params: PutV8DashboardsWidgetsByWidgetValueIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>,
  TError,
  {
    widgetValueId: number;
    data: BodyType<DashboardWidgetGroupValueV8>;
    params: PutV8DashboardsWidgetsByWidgetValueIdParams;
  },
  TContext
> => {
  const mutationKey = ['putV8DashboardsWidgetsByWidgetValueId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>,
    {
      widgetValueId: number;
      data: BodyType<DashboardWidgetGroupValueV8>;
      params: PutV8DashboardsWidgetsByWidgetValueIdParams;
    }
  > = (props) => {
    const { widgetValueId, data, params } = props ?? {};

    return putV8DashboardsWidgetsByWidgetValueId(widgetValueId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV8DashboardsWidgetsByWidgetValueIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>
>;
export type PutV8DashboardsWidgetsByWidgetValueIdMutationBody =
  BodyType<DashboardWidgetGroupValueV8>;
export type PutV8DashboardsWidgetsByWidgetValueIdMutationError = ErrorType<unknown>;

/**
 * @summary 위젯 하나 수정
 */
export const usePutV8DashboardsWidgetsByWidgetValueId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>,
      TError,
      {
        widgetValueId: number;
        data: BodyType<DashboardWidgetGroupValueV8>;
        params: PutV8DashboardsWidgetsByWidgetValueIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof putV8DashboardsWidgetsByWidgetValueId>>,
  TError,
  {
    widgetValueId: number;
    data: BodyType<DashboardWidgetGroupValueV8>;
    params: PutV8DashboardsWidgetsByWidgetValueIdParams;
  },
  TContext
> => {
  const mutationOptions = getPutV8DashboardsWidgetsByWidgetValueIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
